import React from "react";
import { connect } from "react-redux";
import { goBack } from "react-router-redux";
import {
  KerberosForm,
  DevLoginForm,
} from "../../../components/forms/LoginForms";
import { kerberosLoginAction, loginAction } from "../../../../../utils/login";
import PublicPage from "../../../components/PublicPage";

const ConnectedKerberosForm = connect(null, {
  onSubmit: kerberosLoginAction(
    "/administrator/api/auth/kerberos",
    "/administrator/funkcionari",
  ),
  goBack,
})(KerberosForm);

const ConnectedDevForm = connect(null, {
  onSubmit: loginAction(
    "/opravneny-organ/api/auth/basic",
    "/administrator/funkcionari",
  ),
  goBack,
})(DevLoginForm);

const AdministratorLogin = () => (
  <PublicPage title="Přihlášení administrátora">
    <ConnectedKerberosForm title="Přihlášení administrátora" />
    {(process.env.NODE_ENV !== "production" ||
      process.env.REACT_APP_DEV_LOGIN === "true") && <ConnectedDevForm />}
  </PublicPage>
);

export default AdministratorLogin;
